<style lang="scss">
.calculation-input-row {
  align-items: baseline;

  &:not(:last-of-type) {
    margin-bottom: 4rem;
  }

  &__name {
    font-size: 5rem;
    font-weight: bold;
    padding: 0 !important;
  }

  &__value {
    font-size: 6rem;
    font-weight: bold;
    text-align: right;
    padding: 0 !important;
  }

  &__unit {
    font-size: 2rem;
    color: color(grey);
    padding: 0 !important;
  }
}
</style>

<template>
  <v-row class="calculation-input-row">
    <v-col
      :size="7"
      class="calculation-input-row__name"
    >
      <span>{{ formattedName }}</span>
    </v-col>
    <v-col
      :size="3"
      class="calculation-input-row__value"
    >
      <span class="value">{{ value | formatPrice }}</span>
    </v-col>
    <v-col
      :size="1"
      class="calculation-input-row__unit"
    >
      <span class="unit">{{ unit }}</span>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'CalculationInputRow',
  props: {
    name: {
      type: String,
      default: '',
    },
    value: {
      type: Number,
      default: null,
    },
    unit: {
      type: String,
      default: '€/mt',
    },
  },
  computed: {
    formattedName() {
      if (this.name === 'Production Costs') {
        return 'Production';
      }

      return this.name;
    },
  },
};
</script>
